import { render } from "./static-content-create-import.vue?vue&type=template&id=442149ab"
import script from "./static-content-create-import.vue?vue&type=script&lang=js"
export * from "./static-content-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__